import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "heatmaps-section-header" }
const _hoisted_2 = { class: "heatmaps-header-text" }
const _hoisted_3 = { class: "chart-grid heatmaps" }

import DashboardMissingSettings from './DashboardMissingSettings.vue'
import DashboardMissingFilter from './DashboardMissingFilter.vue'
import DashboardMissingData from './DashboardMissingData.vue'
import GraphHeatmapCard from './cards/GraphHeatmapCard.vue'
// import InfoLabel from '@/design-system/molecules/InfoLabel.vue'
import { useHeatmapComponentMap } from '../composables/useHeatmapComponentMap'
import { computed, inject, toRefs, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRealm } from '@/composables/useRealm'
import { sharedDataKey } from '../../types'
import { useStore } from 'vuex'
import { FeatureType, useFilters } from '@/composables/useFilters'
import { useDataFetcher } from '@/composables/useDataFetcher'
import { LocaleString } from '@/api-client/models/utilization/Contracts'
type Props = {
  title: LocaleString
  info?: LocaleString
  heatmap?: any
  isMissingData: boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'HeatmapSection',
  props: {
    title: {},
    info: {},
    heatmap: {},
    isMissingData: { type: Boolean }
  },
  setup(__props: any) {

const sharedData = inject(sharedDataKey)
const realm = useRealm()
const filters = useFilters(FeatureType.Utilization)
const heatmap = useDataFetcher('fetch.utilization.heatmap')
const heatmaps = computed(() => realm.settings?.config?.utilization.heatmaps)
const { submitted } = toRefs(filters)
const heatmapMap = useHeatmapComponentMap(heatmap, submitted)
const store = useStore()
const mobileScreen = computed<boolean>(() => store.state.mobileScreen)
const { t } = useI18n()



onMounted(() => {
  sharedData?.updateSectionIndex(2)
})

const isMissingSettings = computed(() => {
  if (!heatmaps.value && !realm.error) {
    return true
  }
  return false
})

const isMissingFilter = computed(() => {
  if (
    !filters.submitted?.complex &&
    filters.submitted?.buildings.length === 0 &&
    !filters.submitted?.level
  ) {
    return true
  }
  return false
})

return (_ctx: any,_cache: any) => {
  return (isMissingSettings.value)
    ? (_openBlock(), _createBlock(DashboardMissingSettings, { key: 0 }))
    : (isMissingFilter.value)
      ? (_openBlock(), _createBlock(DashboardMissingFilter, { key: 1 }))
      : (_ctx.isMissingData)
        ? (_openBlock(), _createBlock(DashboardMissingData, { key: 2 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createElementVNode("section", _hoisted_1, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('dashboard__text__chart-heatmaps')), 1)
            ]),
            _createElementVNode("section", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(heatmapMap), (hm, type) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: type }, [
                  (hm.show)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["chart", { fullscreen: _unref(sharedData)?.fullscreen, mobile: mobileScreen.value }])
                      }, [
                        (_openBlock(), _createBlock(GraphHeatmapCard, _mergeProps({
                          key: `${_unref(sharedData)?.fullscreen} ${_ctx.isMissingData}`,
                          settings: heatmaps.value?.find((p) => p.type === type),
                          accessKey: hm.accessKey
                        }, { ref_for: true }, hm.props), null, 16, ["settings", "accessKey"]))
                      ], 2))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ], 64))
}
}

})